import React, { useEffect } from "react";

import {
  fetchGraphQL,
  fetchQuizQuestionUpload,
} from "../../../services/api-raindrop";

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";

import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import Image from "../../../ui-components/image/Image.tsx";
const QuizQuestionListItem = ({ question }) => {
  return (
    <div className="flex flex-row gap-2">
      <RaindropCard>
        <div className="flex flex-row gap-4 w-full items-center">
          <Image
            id={"quiz-img"}
            src={question.image.presignedUrl}
            alt="#"
            className="h-20 aspect-auto rounded-lg"
          />
          <div className="flex flex-col gap-2 w-full text-left">
            <div className="font-black text-2xl">{question.answer}</div>
            <div>{question.id}</div>
          </div>
        </div>
      </RaindropCard>
    </div>
  );
};

const QuizQuestionList = ({ questions }) => {
  if (!questions) {
    return (
      <div className="flex flex-col h-full p-6 bg-blue-300">No questions</div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {questions.map((question) => (
        <QuizQuestionListItem key={question.id} question={question} />
      ))}
    </div>
  );
};

const QuizAddNewQuestion = ({
  selectedCategory,
  setRefreshCounter = (x) => {},
}) => {
  const [newAnswer, setNewAnswer] = React.useState("");
  const [file, setFile] = React.useState<File | null>(null);

  const [isLoading, setIsLoading] = React.useState(false);

  const onSubmit = () => {
    console.log("RD-6665", selectedCategory);
    if (!file) {
      console.error("RD-6665", "No file selected");
      return;
    }
    if (!selectedCategory) {
      console.error("RD-6665", "No category selected");
      return;
    }
    if (!newAnswer) {
      console.error("RD-6665", "No answer provided");
      return;
    }

    setIsLoading(true);

    fetchQuizQuestionUpload({
      categoryId: selectedCategory.id,
      file: file,
      answer: newAnswer,
    })
      .then((res) => {
        console.log("RD-6665", res);
        setNewAnswer("");
        setFile(null);
        setRefreshCounter((prev) => prev + 1);
      })
      .catch((err) => {
        console.error("RD-6665", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <RaindropCard>
      <RaindropInputFile
        label={"Upload Image"}
        onChange={(e) => setFile(e.target.files[0])}
      />
      <RaindropInput
        label={"Answer"}
        value={newAnswer}
        onChange={(e) => setNewAnswer(e.target.value)}
      />
      <RaindropButton
        title="Add Question"
        isLoading={isLoading}
        onClick={onSubmit}
      />
    </RaindropCard>
  );
};

const NewCategoryForm = ({ setRefreshCounterCategories = (x) => {} }) => {
  const [newCategoryName, setNewCategoryName] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const onSubmit = () => {
    if (!newCategoryName) {
      console.error("RD-6665", "No category name provided");
      return;
    }
    setIsLoading(true);
    fetchGraphQL(`
      mutation {
        quizCategoryCreate(
          name: "${newCategoryName}"
        ) {
          id
          name
        }
      }
    `)
      .then((res) => {
        console.log("RD-6665", res);
        setNewCategoryName("");
        setRefreshCounterCategories((prev) => prev + 1);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <RaindropCard>
      <RaindropInput
        label={"Category Name"}
        value={newCategoryName}
        onChange={(e) => setNewCategoryName(e.target.value)}
      />
      <RaindropButton
        title="Add Category"
        onClick={onSubmit}
        isFluid={true}
        style={ButtonStyle.Secondary}
        isLoading={isLoading}
      />
    </RaindropCard>
  );
};

const CategoryListItem = ({
  category,
  setSelectedCategory,
  setRefreshCounterCategories,
}) => {
  const onActivate = () => {
    fetchGraphQL(`
      mutation {
        quizCategoryActivate(
          quizCategoryId: "${category.id}"
        ) {
          id
          name
          state
        }
      }
    `).then((res) => {
      console.log("RD-6665", res);
      setRefreshCounterCategories((prev) => prev + 1);
      setSelectedCategory(category);
    });
  };
  return (
    <RaindropClickable
      key={category.id}
      onClick={() => setSelectedCategory(category)}
    >
      <div key={category.id} className="flex flex-col gap-2 w-full">
        <RaindropCard>
          <div className="font-black text-2xl">{category.name}</div>
          <div>{category.id}</div>
          <div>{category.state}</div>
          <RaindropButton title="Activate" onClick={onActivate} />
        </RaindropCard>
      </div>
    </RaindropClickable>
  );
};

const CategoryList = ({
  categoryObjects,
  setSelectedCategory = (x) => {},
  setRefreshCounterCategories = (x) => {},
}) => {
  return (
    <div className="flex flex-col w-full h-full p-2  overflow-y-auto gap-2">
      {categoryObjects?.map((category) => (
        <CategoryListItem
          key={category.id}
          category={category}
          setSelectedCategory={setSelectedCategory}
          setRefreshCounterCategories={setRefreshCounterCategories}
        />
      ))}
    </div>
  );
};
const QuizRightHandlePanel = ({
  categoryObjects,
  setSelectedCategory = (x) => {},
  setRefreshCounterCategories = (x) => {},
}) => {
  if (!categoryObjects) {
    return (
      <div className="flex flex-col h-full p-6 bg-blue-300">Loading...</div>
    );
  }
  return (
    <div className="flex flex-col h-full py-4">
      <NewCategoryForm
        setRefreshCounterCategories={setRefreshCounterCategories}
      />
      <CategoryList
        categoryObjects={categoryObjects}
        setSelectedCategory={setSelectedCategory}
        setRefreshCounterCategories={setRefreshCounterCategories}
      />
    </div>
  );
};

const QuizLeftHandlePanel = ({
  questions,
  selectedCategory,
  setRefreshCounter = (x) => {},
}) => {
  return (
    <div className="flex flex-col gap-4  w-full h-full overflow-y-auto no-scrollbar">
      <QuizAddNewQuestion
        selectedCategory={selectedCategory}
        setRefreshCounter={setRefreshCounter}
      />
      <QuizQuestionList questions={questions} />
    </div>
  );
};

const NimbusQuiz = () => {
  const [categoryObjects, setCategoryObjects] = React.useState(null);
  const [questions, setQuestions] = React.useState(null);

  const [selectedCategory, setSelectedCategory] = React.useState(null);

  const [refreshCounter, setRefreshCounter] = React.useState(0);
  const [refreshCounterCategories, setRefreshCounterCategories] =
    React.useState(0);

  // Fetch categories
  useEffect(() => {
    fetchGraphQL(`
      query {
        quizCategoryObjects {
          id
          name
          state
        }
      }
    `).then((res) => {
      if (res?.data?.quizCategoryObjects) {
        setCategoryObjects(res.data.quizCategoryObjects);
      }
    });
  }, [refreshCounterCategories]);

  // Fetch questions
  useEffect(() => {
    if (!selectedCategory) return;

    fetchGraphQL(`
      query {
        quizQuestionObjects(
          categoryId: "${selectedCategory.id}"
        ) {
          id
          answer
          image {
            presignedUrl
          }  
        }
      }
    `)
      .then((res) => {
        if (res?.data?.quizQuestionObjects) {
          setQuestions(res.data.quizQuestionObjects);
        }
      })
      .catch((err) => {
        console.error("RD-6665", err);
        setQuestions(null);
      });
  }, [selectedCategory, refreshCounter]);

  return (
    <div className="flex flex-row h-full items-center justify-center text-center gap-4">
      <QuizRightHandlePanel
        categoryObjects={categoryObjects}
        setSelectedCategory={setSelectedCategory}
        setRefreshCounterCategories={setRefreshCounterCategories}
      />
      <QuizLeftHandlePanel
        questions={questions}
        selectedCategory={selectedCategory}
        setRefreshCounter={setRefreshCounter}
      />
    </div>
  );
};

export default NimbusQuiz;
